import React, { useState } from "react";
import NavBar from "../../components/NavBar/NavBar";
import BannerCashback from "./components/BannerCashback/BannerCashback";
import TopCashbackStores from "./components/TopCahsbackStores/TopCashbackStores";
import Footer from '../../components/Footer/Footer';

const TopCashback = () => {
    const [selectedLetter, setSelectedLetter] = useState("Todos");
    return (
        <>
        <NavBar variant="default" />
        <BannerCashback />
        <TopCashbackStores selectedLetter={selectedLetter} setSelectedLetter={setSelectedLetter} />
        <Footer/>
        </>
    );
};

export default TopCashback;
